// extracted by mini-css-extract-plugin
export default {"buttons":"NavBar_buttons__V7tlz","footer":"NavBar_footer__H9JUr"};